'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import { useState } from 'react';

import Image from 'next/image';
import Link from 'next/link';

import type { ManufacturerIndex } from '@eliadmin/core/src/api/manufacturers/types/manufacturers-types';

import { BsArrowRight } from 'react-icons/bs';

import { Heading } from '@eliadmin/core/src/components/ui/heading';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';
import { LuMinus, LuPlus } from 'react-icons/lu';
import { Paragraph } from '@eliadmin/core/src/components/ui/paragraph';

export function Manufacturers({
  manufacturers,
  subtitle,
  title,
}: {
  manufacturers: ManufacturerIndex[];
  subtitle: string;
  title: string;
}) {
  const { t } = useTranslations();
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section
      className={cn(
        'custom-section',
        'gap-6 py-5 sm:gap-8 sm:py-6 md:gap-10 md:py-8 lg:gap-[50px] lg:py-[50px]',
      )}
    >
      <Heading title={title} subtitle={subtitle} center />
      <div
        className={cn(
          'custom-container',
          'grid grid-cols-1 gap-3 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:gap-6',
        )}
      >
        {manufacturers.map((manufacturer, index) => {
          const isOpen = openIndex === index;

          const hasImage = !!manufacturer?.image?.url;

          if (hasImage)
            return (
              <div
                key={manufacturer.name}
                className={cn(
                  'relative flex h-fit w-full flex-col items-center justify-center gap-6 rounded-[12px] bg-white p-6',
                  'ea-manufacturer-card',
                )}
              >
                {/* <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? null : index)}
                  aria-expanded={isOpen}
                  className="absolute right-6 top-6 z-10 text-primary"
                >
                  {isOpen ? <LuMinus size={22} /> : <LuPlus size={22} />}
                </button> */}
                <Image
                  src={manufacturer?.image?.url ?? '/images/placeholder.png'}
                  alt={resolveImageAlt(manufacturer?.image, manufacturer?.name)}
                  width={0}
                  height={0}
                  className="h-14 w-auto object-contain object-center"
                  sizes="300px"
                />

                {/* <Paragraph 
                      size='sm'
                      className='w-full text-center line-clamp-6'
                      innerHtml={manufacturer?.short_description ?? ''}
                    /> */}
                <Link
                  prefetch={false}
                  href={manufacturer?.slug}
                  className="flex items-center justify-center gap-2 text-center text-sm font-medium text-primary lg:text-base"
                >
                  {t('text3875')}
                  <BsArrowRight size={18} />
                </Link>
              </div>
            );
        })}
      </div>
    </section>
  );
}
